export function showAlertModal(options: {
  title: string
  message: string
  confirmLabel?: string
}): void {
  const { title, message, confirmLabel = 'OK' } = options

  const overlay = document.createElement('div')
  overlay.className = 'fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50'
  overlay.style.backdropFilter = 'blur(4px)'

  overlay.innerHTML = `
    <div class="bg-white rounded-lg shadow-2xl max-w-sm w-full mx-4 overflow-hidden">
      <div class="p-6 space-y-4">
        <div>
          <h2 class="text-xl font-semibold text-gray-900">${title}</h2>
          <p class="mt-2 text-sm text-gray-600">${message}</p>
        </div>
        <div class="flex justify-end">
          <button
            id="alert-modal-confirm"
            class="bg-indigo-600 text-white px-4 py-2 rounded-md font-medium hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          >
            ${confirmLabel}
          </button>
        </div>
      </div>
    </div>
  `

  function closeModal(): void {
    overlay.remove()
  }

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      closeModal()
    }
  })

  overlay.querySelector('#alert-modal-confirm')?.addEventListener('click', () => {
    closeModal()
  })

  document.body.appendChild(overlay)
}
